import React from 'react';
import { Loading, Modal } from '@brighterion/br-ui';
import type { ScheduledDeploymentContentProps } from '../ScheduledDeploymentContent';

import styles from './IsLoading.css';

export const IsLoading: React.FC<ScheduledDeploymentContentProps> = ({
    children,
    closeModal,
    modal,
    status,
    ...props
}) => {
    const { id, name, title } = modal;
    return (
        <>
            <Modal.Title id={name ?? id} onClose={closeModal} statusIcon={status} title={title} />
            <div className={styles.container} {...props}>
                <p>Processing Deployment Updates...</p>
                <Loading size='xlg' fillName='dark-orange' />
            </div>
            <Modal.Footer id={name ?? id} onClose={closeModal} />
        </>
    );
};
